export enum FollowSuccessStatusEnum {
  CREATE = 'CREATE',
  REMOVE = 'REMOVE',
}
